import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Switch } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Profil from './pages/Profil';
import Post from './pages/Post';
import List from './pages/List';
import Download from './pages/Download';
import Kepegawaian from './pages/Kepegawaian';
import Keuangan from './pages/Keuangan';
import Perencanaan from './pages/Perencanaan';
import Uhtb from './pages/Uhtb';
import Ppid from './pages/Ppid';
import AdminApp from "./admin/AdminApp";
import SiteLayout from "./components/SiteLayout";
import News from './pages/News';
import Announcements from './pages/Announcements';
import NotFound from "./pages/NotFound";

const App = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const response = await fetch('/posts/posts.json');
      const postList = await response.json();
      /*const postList = [
        { id: 'post1', title: 'My First Blog Post' },
        { id: 'post2', title: 'My Second Blog Post' },
        { id: 'post3', title: 'My Third Blog Post' }
      ];*/
      setPosts(postList);
    };

    fetchPosts();

    
  }, []);


  return (
<Router>
      <Routes>
        {/* Semua route publik dibungkus SiteLayout */}
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/profil" element={<Profil />} />
          <Route path="/post/:dir/:id" element={<Post />} />
          <Route path="/list/:dir" element={<List />} />
          <Route path="/download/*" element={<Download />} />
          <Route path="/kepegawaian/*" element={<Kepegawaian />} />
          <Route path="/keuangan/*" element={<Keuangan />} />
          <Route path="/perencanaan/*" element={<Perencanaan />} />
          <Route path="/uhtb/*" element={<Uhtb />} />
          <Route path="/ppid" element={<Ppid />} />
          <Route path="/berita/:id" element={<News />} />
          <Route path="/pengumuman/:id" element={<Announcements />} />
           <Route path="*" element={<NotFound />} />
        </Route>

        {/* Admin route terpisah tanpa header/footer */}
        <Route path="/admin/*" element={<AdminApp />} />
        
      </Routes>
    </Router>
  );
};

export default App;
